import { clsx } from 'clsx'

export function cn(...inputs) {
  return clsx(inputs)
}

export function formatPrice(price) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price)
}

export function formatNumber(number) {
  return new Intl.NumberFormat('en-US').format(number)
}

export function formatDate(date) {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(new Date(date))
}

export function formatDateTime(date) {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(date))
}

export function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

export function generateSlug(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '')
}

export function validateEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return re.test(email)
}

export function validatePhone(phone) {
  const re = /^[\+]?[1-9][\d]{0,15}$/
  return re.test(phone.replace(/\s/g, ''))
}

export function getFileExtension(filename) {
  return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)
}

export function formatFileSize(bytes) {
  if (bytes === 0) return '0 Bytes'
  
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

export function truncateText(text, maxLength) {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}

export function getStatusColor(status) {
  const statusColors = {
    active: 'badge-success',
    inactive: 'badge-gray',
    VIP: 'badge-warning',
    new: 'badge-success',
    used: 'badge-gray',
    transfer: 'badge-primary',
    available: 'badge-success',
    sold: 'badge-danger',
    reserved: 'badge-warning',
  }
  
  return statusColors[status] || 'badge-gray'
}

export function getImageTypeColor(type) {
  const typeColors = {
    main: 'badge-primary',
    thumbnail: 'badge-success',
    option: 'badge-warning',
    cover: 'badge-danger',
  }
  
  return typeColors[type] || 'badge-gray'
}

export function createFormData(data) {
  const formData = new FormData()
  
  Object.keys(data).forEach(key => {
    if (data[key] !== null && data[key] !== undefined) {
      if (Array.isArray(data[key])) {
        data[key].forEach((item, index) => {
          if (typeof item === 'object' && item !== null) {
            Object.keys(item).forEach(subKey => {
              formData.append(`${key}[${index}].${subKey}`, item[subKey])
            })
          } else {
            formData.append(`${key}[${index}]`, item)
          }
        })
      } else if (typeof data[key] === 'object' && data[key] !== null) {
        formData.append(key, JSON.stringify(data[key]))
      } else {
        formData.append(key, data[key])
      }
    }
  })
  
  return formData
}

export function parseFormData(formData) {
  const data = {}
  
  for (let [key, value] of formData.entries()) {
    if (key.includes('[') && key.includes(']')) {
      // Handle array notation
      const arrayKey = key.split('[')[0]
      if (!data[arrayKey]) data[arrayKey] = []
      
      const index = parseInt(key.match(/\[(\d+)\]/)[1])
      if (!data[arrayKey][index]) data[arrayKey][index] = {}
      
      const subKey = key.split('].')[1]
      if (subKey) {
        data[arrayKey][index][subKey] = value
      } else {
        data[arrayKey][index] = value
      }
    } else {
      data[key] = value
    }
  }
  
  return data
}
